import React from "react";
import { AlertCircle } from "lucide-react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export const DeleteCustomerDialog = ({ deleteFor, onClose, onConfirm }) => (
  <AlertDialog open={!!deleteFor} onOpenChange={(o) => !o && onClose()}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle className="flex items-center gap-2"><AlertCircle className="h-4 w-4 text-destructive" /> Delete customer — {deleteFor?.shop_name}?</AlertDialogTitle>
        <AlertDialogDescription>This permanently removes the customer/shop record, including its notes, pricing tier and billing details. Order and invoice history will still reference this shop by name. This cannot be undone.</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>Keep Customer</AlertDialogCancel>
        <AlertDialogAction data-testid="customer-delete-confirm" className="bg-destructive text-destructive-foreground hover:bg-destructive/90" onClick={onConfirm}>Delete Customer</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
